// extracted by mini-css-extract-plugin
export default {"title":"_1LPOh___ContactCard-module__title","content":"_3tmhb___ContactCard-module__content","contactContainer":"_1I6Bb___ContactCard-module__contactContainer"};